module.exports = __webpack_public_path__ + "img/impulse_icon.095548d2.png";